module.exports = __webpack_public_path__ + "img/fdi_red_curve.8ef78bd1.png";